import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, forkJoin } from "rxjs";
import { map, mergeMap, tap } from "rxjs/operators";
import * as _ from 'lodash';
import { FileService, CacheService, ITaskBO, ITypeStateNodeBO } from '@mapfre-tech/amap3';

@Injectable({
   providedIn: "root"
})
export class TaskService {

   className = 'TaskService';

   constructor(private http: HttpClient, private fileService: FileService, private cacheService: CacheService) { }

   getTaskByProgramJobId(programJobId: number): Observable<ITaskBO[]> {
      return this.http.get<ITaskBO[]>(environment.base_URL_GAIA + "/task", { params: { programJobId: programJobId } });
   }

   removeTaskByProgramJobId(programJobId: string): Observable<ITaskBO[]> {
      if (Array.isArray(programJobId)) {
         programJobId = programJobId.join(',');
      }

      return this.http.delete<ITaskBO[]>(environment.base_URL + "/tasks", { params: { programJobId: programJobId } });
   }

   removeTaskByGuideJobId(guideJobId: string): Observable<ITaskBO[]> {
      if (Array.isArray(guideJobId)) {
         guideJobId = guideJobId.join(',');
      }

      return this.http.delete<ITaskBO[]>(environment.base_URL + "/tasks", { params: { guideJobId: guideJobId } });
   }

   createTask(task: ITaskBO): Observable<ITaskBO[]> {
      return this.http.post<ITaskBO[]>(environment.base_URL + "/tasks", task);
   }

   updateTask(task: ITaskBO): Observable<ITaskBO[]> {
      return this.http.put<ITaskBO[]>(environment.base_URL + "/tasks", task);
   }

   saveTask(task: ITaskBO): Observable<ITaskBO[]> {
      return this.http.post<ITaskBO[]>(environment.base_URL + "/tasks", task);
   }


   getStatusTask(cache = true, cacheKey = "taskStatus"): Observable<ITypeStateNodeBO[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeStateNodeBO[]>;
       } else {
         const observable = this.http.get<ITypeStateNodeBO[]>(environment.base_URL + "/types-state-nodes").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newStatusTask(task: ITypeStateNodeBO): Observable<ITypeStateNodeBO[]> {
      return this.http.post<ITypeStateNodeBO[]>(environment.base_URL + "/types-state-nodes", task).pipe(tap(() => this.cacheService.deleteCache('taskStatus')));
   }

   updateStatusTask(task: ITypeStateNodeBO, id: number) {
      return this.http.put(environment.base_URL + `/types-state-nodes/${id}`, task).pipe(tap(() => this.cacheService.deleteCache('taskStatus')))
   }

   saveTaskWithFile(task: ITaskBO): Observable<ITaskBO[]> {
      // PRE FILES INI — only pick real File instances, not already-uploaded metadata objects
      const filesToUpload = ((task.files ?? []) as unknown[]).filter((f): f is File => f instanceof File);
      // PRE FILES END
      //CHECK IF THERE ARE NEW FILES
      if (filesToUpload.length > 0) {
         return this.saveTask(task).pipe(mergeMap((res: ITaskBO[]) => {
            const entityId = String(res);
            let observables: Observable<unknown>[] = filesToUpload.map((f) => this.fileService.upload(f, 'task', entityId));
            return forkJoin(observables).pipe(map(() => res));
         }))
      }
      else {
         return this.saveTask(task);
      }
   }

   export(task: ITaskBO, jobId: number): Observable<ITaskBO[]> {
      const params = {
         jobId
      }
      const options = {
         params,
         responseType: "blob" as 'json'
      }
      return this.http.post<ITaskBO[]>(environment.base_URL_GAIA + "/task/" + task.idTaskPk + "/export", task, options);
   }

   
  /**
   * Calcula el porcentaje de trabajo completado
   * @returns devuelve un numero que se vera reflejado en la barra de progreso
   */
   public calculateProgress(areas: any): number {
      let totalWeight = 0;
       let weightTimesProgress = 0;
       if(areas){
         areas.forEach((area: any) => {
           if(area.tareas){
             area.tareas.forEach((tarea: any) => {
               totalWeight += +tarea.taskWeightProgram;
               weightTimesProgress += (tarea.taskWeightProgram * tarea.taskProgressProgram);
             });
           }
            if (area.subareas){
             area.subareas.forEach((subarea: any) => {
               if(subarea.tareas){
                 subarea.tareas.forEach((tareaSub: any) => {
                   totalWeight += +tareaSub.taskWeightProgram;
                   weightTimesProgress += (tareaSub.taskWeightProgram * tareaSub.taskProgressProgram);
                 });
               }
             })
           }
         });
         if(totalWeight ==0 || isNaN((weightTimesProgress / totalWeight))){
           return 0;
         }else{
         return +(weightTimesProgress / totalWeight).toFixed(2);
         }
       }
       else{
         return 0;
         } 
      }
}
